/**
 * WordPress dependencies
 */
import { store, getContext,getElement, withSyncEvent } from '@wordpress/interactivity';

const { state } = store( 'clientar-blocks', {
	state: {
		formDataSent: sessionStorage.getItem("formDataSent") || false,
	},
	actions: {
		sendData: withSyncEvent( () => {
			document.addEventListener( 'wpcf7mailsent', function(){
				state.formDataSent = sessionStorage.setItem("formDataSent", JSON.stringify(true)) || true;
			});
		}),
			},
			callbacks: {
				formStatus() {
					console.log('Status do Formulário ' + JSON.parse(state.formDataSent));
		    }
	   },
} );
